import { render, staticRenderFns } from "./archivesOfpaper.vue?vue&type=template&id=667fb6f0"
import script from "./archivesOfpaper.vue?vue&type=script&lang=js"
export * from "./archivesOfpaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports